import createApiClient from "./api";

const api = createApiClient();

export const sendOtp = (email) => {
  return api.post("/auth/send-otp", { email });
};

export const verifyOtp = (email, code) => {
  return api.post("/auth/verify-otp", { email, code });
};

export const registerUser = (userData) => {
  return api.post("/auth/register", userData);
};

export const fetchCurrentUser = async () => {
  const token = localStorage.getItem("token");
  const response = await api.get("/auth/me", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  console.log({ ...response.data, id: response.data._id });
  return { ...response.data, id: response.data._id };
};

export const updateUser = async (userData) => {
  const token = localStorage.getItem("token");
  const response = await api.put("/auth/me", userData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};


export const magicLogin = async (token) => {
  try {
    const response = await api.post("/auth/magic-login", { token });
    return response.data;  // Assuming the response contains the user and token
  } catch (error) {
    throw new Error("Invalid magic link: " + error.message);
  }
};

export const getGoogleAuthUrl = async () => {
  const response = await api.get("/auth/google/login");
  return response.data.url;
};

export const getMicrosoftAuthUrl = async () => {
  const response = await api.get("/auth/microsoft/login");
  return response.data.url;
};

export const acceptTerms = (email, token) => {
  const authToken = token || localStorage.getItem("token");
  return api.post(
    "/auth/accept-terms",
    { email },
    authToken
      ? {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      : undefined
  );
};
